import React, { ReactElement, useContext } from 'react';
import { WorkHour } from 'octa-front-sdk';
import DayOfTheWeek from 'octa-front-sdk/dist/enums/DayOfTheWeek';
import OrganizationContext from '../../../../contexts/OrganizationContext';
import { translateDayOfTheWeek } from '../../../../Helpers';
import WorkHoursContentStyles from './styles';

const WorkHoursContent: React.FC = (): ReactElement => {
  const { organizationInfo } = useContext(OrganizationContext);

  let sorted: WorkHour[] = [];

  if (organizationInfo && organizationInfo.workHours.length) {
    sorted = organizationInfo.workHours.sort((a, b): number => {
      const daysOfTheWeek = Object.keys(DayOfTheWeek);
      const dayIndexA = daysOfTheWeek.indexOf(a.dayOfWeek);
      const dayIndexB = daysOfTheWeek.indexOf(b.dayOfWeek);
      const startA = a.start;
      const startB = b.start;

      if (dayIndexA < dayIndexB) return -1;

      if (dayIndexA > dayIndexB) return 1;

      if (startA < startB) return -1;

      if (startA > startB) return 1;

      return 0;
    });
  }

  return (
    <>
      <WorkHoursContentStyles.Title>
        Horários de funcionamento
      </WorkHoursContentStyles.Title>

      <WorkHoursContentStyles.ShiftsList>
        {Object.values(DayOfTheWeek).map((dW, i):
          | ReactElement
          | ReactElement[] => {
          const day = translateDayOfTheWeek(dW).substr(0, 3);
          const intervals = sorted
            .filter((wH): boolean => wH.dayOfWeek === dW)
            .sort((a, b): number => a.start.localeCompare(b.start));

          if (!intervals.length) {
            return (
              <li key={i}>
                <span>
                  <strong>{day}</strong>
                </span>

                <span>Fechado</span>
              </li>
            );
          }
          return intervals.map(
            (interval, j): ReactElement => {
              const label = `${interval.start.substr(
                0,
                5,
              )} às ${interval.end.substr(0, 5)}`;

              return (
                <li key={j}>
                  <span>
                    <strong>{day}</strong>
                  </span>

                  <span>{label}</span>
                </li>
              );
            },
          );
        })}
      </WorkHoursContentStyles.ShiftsList>
    </>
  );
};

export default WorkHoursContent;
